import { jsxs, jsx } from 'react/jsx-runtime';
import 'react';

const SocialX = ({ testId, className })=>{
    return /*#__PURE__*/ jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: [
            /*#__PURE__*/ jsx("rect", {
                width: "16",
                height: "16",
                rx: "8",
                fill: "black"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M10.3005 4H11.5272L8.84717 7.38872L12 12H9.53136L7.59783 9.20328L5.38544 12H4.15798L7.02452 8.37538L4 4H6.53131L8.27905 6.55631L10.3005 4ZM9.86993 11.1877H10.5497L6.16196 4.76964H5.43253L9.86993 11.1877Z",
                fill: "white"
            })
        ]
    });
};

export { SocialX as default };
